import React, { ChangeEvent, FC, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import _, { compact } from "lodash";
import { useParams } from "react-router-dom";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { IMPORT_REQUEST_EDITABLE_STATUS } from "../../../../constants/common";
import { Confirm, download, qrPdf, Toast } from "../../../../modules/common/helper";
import ProductTable from "./ProductTable";
import { HeaderModel, ModalModel } from "../../../../models/CommonModel";
import { AsyncSelect2 } from "../../../../../_metronic/partials/select/AsyncSelect2";
import { ADMIN_GET_CONSIGN_PRODUCTS_ENDPOINT } from "../../../../constants/endpoints";
import { IInventoryOfSento } from "../../../../models/AgentProduct";
import { ImportRequestDetailModel, ImportRequestModel } from "../../../../models/ImportRequestModel";
import { confirmRequest, exportDetails, exportPdf, getDetail, updateRequest } from "../ImportRequestCRUD";
import DetailInfo from "./DetailInfo";
import ExportQrModal from "./ExportQrModal";
import { openNewTabWithHtml } from "../../../../selectors";
import { exportQrCode } from "../../../order/detail/OrderDetailCRUD";
import { exportHtml } from "../../receipt/detail/ReceiptCRUD";
import { QrExportModel } from "../../../../modules/auth/models/ProductsModel";

const Detail: FC = () => {
  const intl = useIntl()
  const { id } = useParams<{ id?: string }>();
  const [detail, setDetail] = useState<ImportRequestModel>()
  const [editable, setEditAble] = useState<boolean>(false)
  const [selected, setSelected] = useState<number[]>([])
  const [removeIds, setRemoveIds] = useState<number[]>([])
  const schema = Yup.object().shape({});
  const header: HeaderModel[] = [
    {
      label: intl.formatMessage({ id: 'PRODUCTS.NAME' }),
      field: 'name',
      style: { maxWidth: "180px", minWidth: "180px", },
      sortable: false
    },
    {
      label: 'Nhà cung cấp',
      field: 'supplier_name',
      style: { maxWidth: "180px", minWidth: "180px", },
      sortable: false
    },
    {
      label: 'Giá NCC',
      field: 'supplier_price',
      style: { minWidth: "180px", },
      sortable: false
    },
    {
      label: 'SL đặt',
      field: 'request_quantity',
      style: { maxWidth: "100px", minWidth: "100px", },
      sortable: false
    },
    {
      label: 'SL giao',
      field: 'quantity',
      style: { maxWidth: "100px", minWidth: "100px", },
      sortable: false
    },
    {
      label: 'VAT',
      field: 'vat',
      style: { maxWidth: "50px", minWidth: "50px", },
      sortable: false
    },
    {
      label: 'Tồn kho',
      field: 'warehouse',
      style: { maxWidth: "80px", minWidth: "80px", },
      sortable: false
    },
    {
      label: 'Ghi chú',
      field: 'note',
      style: { maxWidth: "150px", minWidth: "150px", },
      sortable: false
    }
  ]

  const [hideCols, setHideCols] = useState<string[]>([
    
  ]);
  const [configModal, setConfigModal] = useState<ModalModel>({
    show: false,
    mode: 'add',
  });

  useEffect(() => {
    document.title = 'Sento - Chi tiết đơn nhập';
  })

  useEffect(() => {
    getDetailData();
  }, []);

  const getDetailData = async () => {
    const { data } = await getDetail(id);
    setDetail(data.data);
    setEditAble(IMPORT_REQUEST_EDITABLE_STATUS.includes(data.data?.status ?? ''));
    let isApprovedIds = data.data?.details?.filter((el: ImportRequestDetailModel) => el.is_approved === 1).map((el: ImportRequestDetailModel) => el.consign_product_id ?? 0) || [];
    setSelected(isApprovedIds);
  }

  const handleSubmit = async () => {
    if (selected.length === 0 && (detail?.is_incorrect_quality === 1 || detail?.is_incorrect_quantity === 1)) {
      Toast.fire({
        icon: 'warning',
        title: 'Vui lòng chọn sản phẩm để cập nhật',
      })
      return;
    }
    try {
      if (detail && detail.id) {
        const { data } = await updateRequest(
          detail.id, 
          formatSelectedItems(), 
          removeIds, 
          false
        )
        Toast.fire({
          icon: 'success',
          title: data?.message || intl.formatMessage({ id: 'COMMON.SUCCESS_NOTY' }),
        })
        getDetailData();
      }
    } catch (error: any) {
      Toast.fire({
        icon: 'error',
        title: error?.response?.data?.message,
      })
    }
  }
  const toggleCheck = (e: ChangeEvent<HTMLInputElement>, item: ImportRequestDetailModel) => {
    let newSelected = [...selected];
    if (item.consign_product_id) {
      let isApproved = 0;
      if (e.target.checked) {
        newSelected.push(item.consign_product_id);
        isApproved = 1;
      } else {
        newSelected = newSelected.filter(el => el !== item.consign_product_id)
        isApproved = 0
      }
      let requestDetails = [...detail?.details ?? []];
      let findIndex = requestDetails.findIndex(el => el.consign_product_id === item.consign_product_id);
      if (findIndex >= 0) {
        requestDetails[findIndex] = {
          ...requestDetails[findIndex],
          is_approved: isApproved
        }
        setDetail({
          ...detail,
          details: requestDetails
        })
      }
      setSelected(newSelected);
    }
    
  }
  const handleChangeQty = (e: ChangeEvent<HTMLInputElement>, item: ImportRequestDetailModel) => {
    let requestDetails = [...detail?.details ?? []];
    let findIndex = requestDetails.findIndex(el => el.consign_product_id === item.consign_product_id);
    if (findIndex >= 0) {
      if (e.target.name === 'request_quantity') {
        requestDetails[findIndex] = {
          ...requestDetails[findIndex],
          quantity: parseInt(e.target.value),
          request_quantity: parseInt(e.target.value)
        }
      } else {
        requestDetails[findIndex] = {
          ...requestDetails[findIndex],
          quantity: parseInt(e.target.value)
        }
      }
    }
    setDetail({
      ...detail,
      details: requestDetails
    })
  }

  const handleChangeNote = (e: ChangeEvent<HTMLInputElement>, item: ImportRequestDetailModel) => {
    let requestDetails = [...detail?.details ?? []];
    let findIndex = requestDetails.findIndex(el => el.consign_product_id === item.consign_product_id);
    if (findIndex >= 0) {
      requestDetails[findIndex] = {
        ...requestDetails[findIndex],
        note: e.target.value
      }
    }
    setDetail({
      ...detail,
      details: requestDetails
    })
  }

  const formatSelectedItems = () => {
    let importRequest = {...detail}
    let details = importRequest?.details ?? [];
    details = details.map((el) => {
      if (importRequest?.is_incorrect_quantity !== 1 && importRequest?.is_incorrect_quality !== 1) {
        return { ...el, is_approved: 1 }
      }
      if (selected.includes(el.consign_product_id ?? 0)) {
        return { ...el, is_approved: 1 }
      } else {
        return el
      }
    })
    importRequest.details = details;
    return importRequest;
  }


  const handleRemoveItems = (ids: number[]) => {
    let requestDetails = [...detail?.details ?? []];
    let removeIds: (number|null)[] = [];
    let newDetails = requestDetails.map((el) => {
      if (!ids.includes(el.consign_product_id ?? 0)) {
        return el
      } else {
        removeIds.push(el.id ?? null)
        return null
      }
    })

    setDetail({
      ...detail,
      details: compact(newDetails)
    })
    setSelected([]);
    setRemoveIds(compact(removeIds))
  }

  const handleChangeDetail = (e: any) => {
    let value = e.target.value;

    if (e.target.type === 'checkbox') {
      value = e.target.checked ? 1 : 0;
    }

    setDetail({
      ...detail,
      [e.target.name]: value
    })
  }

  const handleSelectProduct = (item: IInventoryOfSento) => {
    let importDetails = detail?.details ?? [];
    let consignPdId = item.consign_pd_id;
    let currentIds = importDetails.map(el => el.consign_product_id)
    if (currentIds.includes(consignPdId)) {
      return false;
    }

    if (item.best_supplier) {
      importDetails.push({
        consign_product_id: consignPdId,
        inventory_of_supplier_id: item.best_supplier?.id,
        unit_price: item.best_supplier?.price,
        quantity: 1,
        request_quantity: 1,
        vat: item.vat,
        product: {
          id: item.best_supplier.id,
          inventory_of_sento: item,
          supplier: item.best_supplier?.supplier,
          warehouse: item.best_supplier.warehouse
        }
      })
    }

    setDetail({
      ...detail,
      details: importDetails
    })
      
  }

  const handleConfirm = async () => {
    Confirm.fire({
        icon: 'question',
        title: 'Xác nhận đã nhận hàng',
        confirmButtonText: intl.formatMessage({ id: 'COMMON.YES' }),
        cancelButtonText: intl.formatMessage({ id: 'COMMON.NO' }),
    }).then(async (res) => {
        if (res.isConfirmed && id) {
            try {
                if (detail?.id && (detail?.is_incorrect_quantity === 1 || detail?.is_incorrect_quality === 1)) {
                  if (selected.length === 0) {
                    Toast.fire({
                      icon: 'warning',
                      title: 'Vui lòng chọn sản phẩm để cập nhật',
                    })
                    return;
                  }
                  const res = await updateRequest(
                    detail.id, 
                    formatSelectedItems(), 
                    removeIds, 
                    true
                  );
                  Toast.fire({
                      icon: 'success',
                      title: intl.formatMessage({ id: 'COMMON.SUCCESS_NOTY' }),
                  })
                } else {
                  const res = await confirmRequest([parseInt(id)]);
                  Toast.fire({
                      icon: 'success',
                      title: res?.data?.message || intl.formatMessage({ id: 'COMMON.SUCCESS_NOTY' }),
                  })
                }
            } finally {
                getDetailData();
            }
        }
        
    })
  }

  const handleExportPdf = async () => {
      if (detail?.id) {
        const {data: resData} = await exportPdf({id: detail.id})
        openNewTabWithHtml(resData);
      }
  }

  const handleExportCSV = async () => {
    if (detail?.id) {
      const {data} = await exportDetails(detail.id);
      download(data, `import-request-${detail.code}`);
    }
  }

  const [qrReqData, setQrReqData] = useState<QrExportModel[]>([]);

  const [qrExportModal, setQrExportModal] = useState<ModalModel>({
      show: false,
      mode: 'add',
  });

  const handleSetExportData = (index: number, name: string, url: string, nums: number, id: number|string) => {
    let reqItems = [...qrReqData];
    let itemIndex = reqItems.findIndex((e: QrExportModel) => e.url == url);
    let item = {index: index, name: name, url: url, nums: nums, id};
    if (itemIndex != -1) {
      item = {...reqItems[itemIndex], nums: nums};
      reqItems[itemIndex] = item;
    } else {
      reqItems.push(item);
    }
    setQrReqData(reqItems)
  }

  const hanldeCheckQr = (index: number, name: string, url: string, checked: boolean, id: number|string) => {
    let reqItems = [...qrReqData];
    if (!checked) {
      setQrReqData(reqItems.filter((e: QrExportModel) => e.url !== url))
    } else {
      reqItems.push({index: index, name: name, url: url, nums: 1, id});
      setQrReqData(reqItems)
    }
  }

  const handleExportQr = async (isPrinter = false) => {
    if (!qrReqData?.length || qrReqData?.length === 0) {
      Toast.fire({
        icon: 'warning',
        title: 'Vui lòng chọn sản phẩm',
      })
      return false;
    }
    const {data} = await exportQrCode({reqData: qrReqData, isPrinter: isPrinter ? 1 : 0});
    if (isPrinter) {
      qrPdf(data, 'receipt-qr', 'tp80');
    } else {
      openNewTabWithHtml(data);
    }
  }

  const handlePrintQr = async () => {
    if (!qrReqData?.length || qrReqData?.length === 0) {
      Toast.fire({
        icon: 'warning',
        title: 'Vui lòng chọn sản phẩm',
      })
      return false;
    }
    const {data} = await exportHtml({reqData: qrReqData});
    openNewTabWithHtml(data);
  } 

  return (
    <Formik enableReinitialize validationSchema={schema}
      initialValues={{}} onSubmit={handleSubmit}>
      {({ values, handleChange }) => {
        let selectedPdIds: any[] = detail?.details?.map((el) => {
          return {
            value: el.product?.inventory_of_sento.id, 
            label: el.product?.inventory_of_sento?.name
          }
        }) ?? [];
        return (
          <>
            <Form>
              <div className="card">
                <DetailInfo
                  detail={detail}
                  editable={editable}
                  handleChangeDetail={handleChangeDetail}
                  handleSubmit={handleSubmit}
                  handleConfirm={handleConfirm}
                  handleExportPdf={handleExportPdf}
                  handleExportCSV={handleExportCSV}
                  handleShowExportModal={() => setQrExportModal({...qrExportModal, show: true})}
                  isIncorrect={detail?.is_incorrect_quality === 1 || detail?.is_incorrect_quantity === 1}
                />
                <div className="card-body p-3">
                  {editable && (
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <label className="text-bold">Thêm sản phẩm:</label>
                        <AsyncSelect2
                          sourceUrl={`${ADMIN_GET_CONSIGN_PRODUCTS_ENDPOINT}`}
                          filterQuery={`&supplier_id=${detail?.sento_supplier?.id}`}
                          isGetAll={true}
                          value={selectedPdIds}
                          defaultOptions
                          default
                          placeholder="Sản phẩm"
                          onChange={(selectedOption: any) => {
                            handleSelectProduct(selectedOption)
                          }}
                        />
                        
                      </div>
                      <div className="col-12 col-md-6 text-end">
                        {selected?.length > 0 && (
                          <button
                            className="col-auto btn btn-danger btn-sm"
                            type="button"
                            onClick={() => handleRemoveItems(selected)}
                          >
                            <i className="bi bi bi-trash fs-4"></i> {intl.formatMessage({id: 'COMMON.DELETE'})}
                          </button>
                        )}
                      </div>
                    </div>
                  )}
                  <ProductTable
                    importRequest={detail}
                    editable={editable}
                    handleChangeQty={handleChangeQty}
                    handleChangeNote={handleChangeNote}
                    toggleCheck={toggleCheck}
                    openColConfig={() => setConfigModal({ ...configModal, show: true })}
                    hideCols={hideCols}
                    headers={header}
                    selected={selected}
                    isIncorrect={detail?.is_incorrect_quality === 1 || detail?.is_incorrect_quantity === 1}
                  />
                </div>
              </div>
            </Form>
            <ExportQrModal
              {...qrExportModal}
              data={detail?.details ?? []}
              qrReqData={qrReqData}
              handleExport={handleExportQr}
              handlePrintQr={handlePrintQr}
              onClose={() => setQrExportModal({...qrExportModal, show: false})}
              handleSetExportData={handleSetExportData}
              handleCheck={hanldeCheckQr}
            />
          </>
        )
      }}
    </Formik>
  )
}
export default Detail;